exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?{\"importLoaders\":1}!../node_modules/postcss-loader/lib/index.js??postcss!@blueprintjs/core/lib/css/blueprint.css"), "");
exports.i(require("-!../node_modules/css-loader/index.js?{\"importLoaders\":1}!../node_modules/postcss-loader/lib/index.js??postcss!@blueprintjs/icons/lib/css/blueprint-icons.css"), "");

// module
exports.push([module.id, "body {\n  margin: 0;\n  padding: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./src/index.css
// module id = 332
// module chunks = 0